// extracted by mini-css-extract-plugin
export default {"iconRight":"wgIPw"};